module.exports = __webpack_public_path__ + "media/images/icon-login-google@3x-3cac4f707683de7ec7f4732e387dd401.png";